import { render } from "./PlanTableCard.vue?vue&type=template&id=087e624e&ts=true"
import script from "./PlanTableCard.vue?vue&type=script&lang=ts"
export * from "./PlanTableCard.vue?vue&type=script&lang=ts"

import "./PlanTableCard.vue?vue&type=style&index=0&id=087e624e&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__